import { render, staticRenderFns } from "./global_reward_add.vue?vue&type=template&id=0a830df2&"
import script from "./global_reward_add.vue?vue&type=script&lang=js&"
export * from "./global_reward_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports